'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.scoresForPersonInEventAreLoading = exports.commentsForPersonInEventAreLoading = exports.getDressCheckAdjForPersonInEvent = exports.getDressCheckForPersonInEvent = exports.getCommentsForPersonInEvent = exports.getScoresForPersonInEvent = exports.personIsLoading = exports.getPerson = exports.feisParticipantUrl = exports.feisParticipantByDancerIdUrl = undefined;

var _immutable = require('immutable');

var feisParticipantByDancerIdUrl = exports.feisParticipantByDancerIdUrl = function feisParticipantByDancerIdUrl(fid, pid) {
  return IFEIS_API_URI + '/api/feiseanna/' + fid + '/participants/' + pid + '/competition-details';
};

var feisParticipantUrl = exports.feisParticipantUrl = function feisParticipantUrl(fid, pid) {
  return IFEIS_API_URI + '/api/feiseanna/' + fid + '/participants/' + pid;
};

var getPerson = exports.getPerson = function getPerson(state, pid) {
  return state.getIn(['persons', 'one', pid]) || (0, _immutable.Map)();
};

var personIsLoading = exports.personIsLoading = function personIsLoading(state, pid) {
  return state.getIn(['persons', 'one', pid, 'loading']);
};

var getScoresForPersonInEvent = exports.getScoresForPersonInEvent = function getScoresForPersonInEvent(state, eid, pid) {
  return state.getIn(['persons', 'scores', pid, eid]) || (0, _immutable.List)();
};

var getCommentsForPersonInEvent = exports.getCommentsForPersonInEvent = function getCommentsForPersonInEvent(state, eid, pid) {
  return state.getIn(['persons', 'comments', pid, eid]) || (0, _immutable.List)();
};

var getDressCheckForPersonInEvent = exports.getDressCheckForPersonInEvent = function getDressCheckForPersonInEvent(state, eid, pid, aid) {
  return state.getIn(['persons', 'dresscheck', pid, eid, aid]) || (0, _immutable.Map)();
};

var getDressCheckAdjForPersonInEvent = exports.getDressCheckAdjForPersonInEvent = function getDressCheckAdjForPersonInEvent(state, eid, pid) {
  return state.getIn(['persons', 'dresscheck', pid, eid]) || (0, _immutable.Map)();
};

var commentsForPersonInEventAreLoading = exports.commentsForPersonInEventAreLoading = function commentsForPersonInEventAreLoading(state, pid) {
  return state.getIn(['persons', 'comments', pid, 'loading']);
};

var scoresForPersonInEventAreLoading = exports.scoresForPersonInEventAreLoading = function scoresForPersonInEventAreLoading(state, pid) {
  return state.getIn(['persons', 'scores', pid, 'loading']);
};


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/actions/person/paths.js
// module id = 57
// module chunks = 0